export const stripePlansPrices: { [key: string]: number } = {
  single: 299,
  monthly: 599,
  annual12: 3299,
  annual24: 5799
};
